export default {"src":"/_next/static/media/right-arrow-black.53efef7f.svg","height":30,"width":17};